import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest, fork, all } from "redux-saga/effects";

import { fetchList, fetchListSuccess, fetchListError } from ".";
import { GET, Response } from "../../../utils/request";
import { Country, FilteringParams } from "./types";
import toast from "../../../components/Toaster";

const path = `/api/locale/countries/get`;
const api = {
  list: () => `${path}`,
};

function* fetchListSaga(
  action: PayloadAction<{
    filtering: FilteringParams;
  }>
) {
  try {
    const response: Response<{ countries: Country[] }> = yield GET(
      api.list(),
      action.payload.filtering
    );

    yield put(fetchListSuccess(response.data.countries));
  } catch (error) {
    yield put(fetchListError(error));
    toast.error(error.message);
  }
}

function* fetchListWatcher() {
  yield takeLatest(fetchList.type, fetchListSaga);
}

export function* rootWatcher() {
  yield all([fork(fetchListWatcher)]);
}

export default rootWatcher;
